export class Trasferta {
    id: any;
    id_utente: any;
    data: any;
    mese: any;
    anno:any;
    giorno:any;
}
